module.exports = __webpack_public_path__ + "img/pathology.9c20ed0d.png";